webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stack_grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remotestorage_widget__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remotestorage_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remotestorage_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LyricsCard__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lyricsList: {},
      searchList: {}
    };
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      this.$rs['multi-language-lyrics'].list().then(function (list) {
        _this.lyricsList = list;
      });
    }
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var widget = new __WEBPACK_IMPORTED_MODULE_1_remotestorage_widget___default.a(this.$rs);
    widget.attach('fab-connect');
  },

  components: {
    'lyrics-card': __WEBPACK_IMPORTED_MODULE_2__LyricsCard__["a" /* default */],
    stack: __WEBPACK_IMPORTED_MODULE_0_vue_stack_grid__["a" /* Stack */],
    'stack-item': __WEBPACK_IMPORTED_MODULE_0_vue_stack_grid__["b" /* StackItem */]
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_images_loaded__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    columnMinWidth: {
      type: Number,
      required: true
    },
    gutterWidth: {
      type: Number,
      default: 0
    },
    gutterHeight: {
      type: Number,
      default: 0
    },
    monitorImagesLoaded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      containerWidth: 0,
      columnCount: 0,
      columnWidth: 0,
      baseColumns: []
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.reflow);
    this.update();
  },

  methods: {
    updateColumnData: function updateColumnData() {
      this.containerWidth = this.getContainerWidth();
      this.columnCount = this.getColumnCount();
      this.columnWidth = this.getColumnWidth();
    },
    getContainerWidth: function getContainerWidth() {
      return this.$refs.container.clientWidth;
    },
    getColumnCount: function getColumnCount() {
      for (var i = 1; true; i++) {
        var w = i * this.columnMinWidth + (i - 1) * this.gutterWidth;
        if (w > this.containerWidth) return Math.max(i - 1, 1);
      }
    },
    getColumnWidth: function getColumnWidth() {
      return (this.containerWidth - (this.columnCount - 1) * this.gutterWidth) / this.columnCount;
    },
    getBaseColumns: function getBaseColumns() {
      var cols = [];
      for (var i = 0; i < this.columnCount; i++) {
        cols.push({
          x: i * (this.columnWidth + this.gutterWidth),
          h: 0
        });
      }return cols;
    },
    update: function update() {
      this.$nextTick(this.reflow);
    },
    reflow: function reflow() {
      var _this = this;

      this.updateColumnData();
      var cols = this.getBaseColumns();

      this.$children.forEach(function (child, i) {
        child.$el.style.width = _this.columnWidth + "px";

        var n = 0;
        if (i < _this.columnCount) n = i;else {
          var minH = -1;
          cols.forEach(function (col, j) {
            if (minH == -1 || col.h < minH) {
              n = j;
              minH = col.h;
            }
          });
        }

        child.$el.style.left = cols[n].x + "px";
        child.$el.style.top = cols[n].h + "px";
        cols[n].h += child.$el.offsetHeight + _this.gutterHeight;
      });

      var containerHeight = 0;
      cols.forEach(function (col) {
        return containerHeight = Math.max(containerHeight, col.h);
      });
      this.$el.style.height = containerHeight + "px";
    },
    imagesLoaded: function imagesLoaded() {
      if (this.monitorImagesLoaded) this.reflow();
    }
  },
  directives: {
    imagesLoaded: __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lyricsObj: {
        title: 'Loading...',
        tags: [],
        lyrics: [{
          lang: 'original',
          lyrics: ''
        }, {
          lang: 'translate',
          lyrics: ''
        }]
      }
    };
  },
  methods: {
    navigate: function navigate() {
      this.$router.push('/view/' + this.id);
    }
  },
  created: function created() {
    var _this = this;

    this.$rs['multi-language-lyrics'].get(this.id).then(function (obj) {
      _this.lyricsObj = obj;
    });
  },

  props: {
    id: {
      required: true
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kuroshiro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kuroshiro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kuroshiro__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      viewingTools: false,
      generating: false,
      editingLyrics: false,
      deleteConfirmation: false,
      title: '',
      tags: [],
      lyrics: [{
        lang: 'original',
        lyrics: ''
      }, {
        lang: 'translate',
        lyrics: ''
      }]
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id !== 'new') {
      this.$rs['multi-language-lyrics'].get(this.$route.params.id).then(function (obj) {
        _this.title = obj.title;
        _this.tags = obj.tags;
        _this.lyrics = obj.lyrics;
      });
    } else {
      this.editingLyrics = true;
    }
  },

  methods: {
    focusIn: function focusIn() {
      this.editingLyrics = true;
    },
    focusOut: function focusOut() {
      if (this.lyrics[0].lyrics !== '') this.editingLyrics = false;
    },
    generateFurigana: function generateFurigana() {
      var _this2 = this;

      this.generating = true;
      __WEBPACK_IMPORTED_MODULE_0_kuroshiro__["init"]({ dicPath: '/static/dict/' }, function () {
        var strippedLyrics = _this2.lyrics[0].lyrics.replace(/{{1}([^{}()]+)}{1}\({1}([^{}()]+)\){1}/gm, '$1');
        var result = __WEBPACK_IMPORTED_MODULE_0_kuroshiro__["convert"](strippedLyrics, {
          mode: 'furigana',
          to: 'hiragana'
        });
        result = result.replace(/<ruby>/gm, '{').replace(/<rp>\(<\/rp><rt>/gm, '}(').replace(/<\/rt><rp>\)<\/rp><\/ruby>/gm, ')');
        _this2.lyrics[0].lyrics = result;
        _this2.generating = false;
      });
    },
    deleteLyrics: function deleteLyrics() {
      var _this3 = this;

      this.$rs['multi-language-lyrics'].deleteLyrics(this.$route.params.id).then(function () {
        _this3.$router.push('/');
      });
    },
    save: function save() {
      var _this4 = this;

      var lyrics = {
        title: this.title,
        tags: this.tags,
        lyrics: this.lyrics
      };
      // console.log(lyrics);
      if (this.$route.params.id === 'new') {
        this.$rs['multi-language-lyrics'].add(lyrics).then(function () {
          // console.log('stored successfully');
          _this4.$router.go(-1);
        });
      } else {
        this.$rs['multi-language-lyrics'].update(this.$route.params.id, lyrics).then(function () {
          // console.log('update successfully');
          _this4.$router.go(-1);
        });
      }
    }
  },
  components: {}
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hiding: false,
      lyricsObj: {
        title: 'Loading...',
        tags: [],
        lyrics: [{
          lang: 'original',
          lyrics: ''
        }, {
          lang: 'translate',
          lyrics: ''
        }]
      }
    };
  },
  methods: {
    splitLines: function splitLines(text) {
      return text.split(/\n/);
    }
  },
  created: function created() {
    var _this = this;

    this.$rs['multi-language-lyrics'].get(this.$route.params.id).then(function (obj) {
      _this.lyricsObj = obj;
    });
  },

  components: {}
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_autosize__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_remotestoragejs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_remotestoragejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_remotestoragejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_input_tag__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(35);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








var uuidv4 = function uuidv4(a) {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuidv4);
}; // eslint-disable-line

var MultiLanguageLyrics = {
  name: 'multi-language-lyrics',
  builder: function builder(privateClient) {
    // console.log(publicClient);
    privateClient.declareType('lyrics', {
      type: 'object',
      properties: {
        id: {
          type: 'string'
        },
        title: {
          type: 'string'
        },
        tags: {
          type: 'array',
          default: []
        },
        lyrics: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              lang: {
                type: 'string'
              },
              lyrics: {
                type: 'string'
              }
            }
          }
        }
      }
    });
    return {
      exports: {
        get: function get(id) {
          return privateClient.getObject('lyrics/' + id);
        },
        list: function list() {
          return privateClient.getListing('lyrics/');
        },
        deleteLyrics: function deleteLyrics(id) {
          return privateClient.remove('lyrics/' + id);
        },
        update: function update(id, lyrics) {
          var lyricsWithId = lyrics;
          lyricsWithId.id = id;
          var path = 'lyrics/' + lyricsWithId.id;
          return privateClient.storeObject('lyrics', path, lyricsWithId).then(function () {
            return lyricsWithId;
          });
        },
        add: function add(lyrics) {
          var lyricsWithId = lyrics;
          lyricsWithId.id = uuidv4();
          var path = 'lyrics/' + lyricsWithId.id;
          return privateClient.storeObject('lyrics', path, lyricsWithId).then(function () {
            return lyricsWithId;
          });
        }
      }
    };
  }
};

var remoteStorage = new __WEBPACK_IMPORTED_MODULE_2_remotestoragejs___default.a({
  modules: [MultiLanguageLyrics]
});
remoteStorage.access.claim('multi-language-lyrics', 'rw');
remoteStorage.caching.enable('/multi-language-lyrics/');
remoteStorage.setApiKeys({
  googledrive: '353415172859-fcrgqj8kic49se2gjmueqel0psckpcp5.apps.googleusercontent.com'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_autosize___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use({
  install: function install(V) {
    /* eslint-disable no-param-reassign */
    V.prototype.$parseRuby = function (text) {
      var ruby = text.replace(/{{1}([^{}()]+)}{1}\({1}([^{}()]+)\){1}/gm, '<ruby>$1<rt>$2</rt></ruby>');
      return ruby;
    };
    V.prototype.$rs = remoteStorage;
    V.prototype.$colorHash = function (inputString) {
      /* eslint-disable */
      var sum = 0;
      for (var i in inputString) {
        sum += inputString.charCodeAt(i);
      }

      var r = ~~(('0.' + Math.sin(sum + 1).toString().substr(6)) * 256);
      var g = ~~(('0.' + Math.sin(sum + 2).toString().substr(6)) * 256);
      var b = ~~(('0.' + Math.sin(sum + 3).toString().substr(6)) * 256);

      var hex = "#";

      hex += ("00" + r.toString(16)).substr(-2, 2).toUpperCase();
      hex += ("00" + g.toString(18)).substr(-2, 2).toUpperCase();
      hex += ("00" + b.toString(20)).substr(-2, 2).toUpperCase();

      return hex;
    };
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('input-tag', __WEBPACK_IMPORTED_MODULE_3_vue_input_tag___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6aab1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6aab1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Editor__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Viewer__ = __webpack_require__(72);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */]
  }, {
    path: '/edit/:id',
    name: 'Editor',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Editor__["a" /* default */]
  }, {
    path: '/view/:id',
    name: 'View',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Viewer__["a" /* default */]
  }]
}));

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480c1ba6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(51);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-480c1ba6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480c1ba6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Stack_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_db70be3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Stack_vue__ = __webpack_require__(43);
function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Stack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_db70be3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Stack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.imagesLoaded),expression:"imagesLoaded"}],ref:"container",staticClass:"container"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StackItem_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StackItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StackItem_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ca18db26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StackItem_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StackItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ca18db26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StackItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stack-item"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyricsCard_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186e88cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LyricsCard_vue__ = __webpack_require__(50);
function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186e88cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyricsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186e88cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LyricsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lyrics-card mdl-card mdl-shadow--2dp",on:{"click":function($event){_vm.navigate()}}},[_c('div',{staticClass:"mdl-card__title",style:('background-color: ' + _vm.$colorHash(_vm.lyricsObj.title) + ';')},[_c('h2',{staticClass:"lyrics-card-title mdl-card__title-text"},[_vm._v(_vm._s(_vm.lyricsObj.title))]),_c('p',{staticClass:"lyrics-preview",domProps:{"innerHTML":_vm._s(_vm.$parseRuby(_vm.lyricsObj.lyrics[0].lyrics.substr(0, 100)) + '...')}})]),_c('div',{staticClass:"mdl-card__supporting-text"},[(_vm.lyricsObj.tags.length > 0)?_c('input-tag',{attrs:{"tags":_vm.lyricsObj.tags,"read-only":"read-only"},on:{"update:tags":function($event){_vm.$set(_vm.lyricsObj, "tags", $event)}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header"},[_c('header',{staticClass:"mdl-layout__header"},[_c('div',{staticClass:"mdl-layout__header-row"},[_c('button',{staticClass:"mdl-layout__drawer-button",on:{"click":function($event){_vm.fetch()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("refresh")])]),_vm._m(0),_c('div',{staticClass:"mdl-layout-spacer"}),_c('nav',{staticClass:"mdl-navigation"},[_c('router-link',{staticClass:"mdl-navigation__link",attrs:{"to":"/edit/new"}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])],1)])]),_c('main',{staticClass:"mdl-layout__content"},[_c('div',{staticClass:"page-content"},[_c('div',{attrs:{"id":"fab-connect"}}),(Object.keys(_vm.lyricsList).length > 0)?_c('div',[_c('stack',{staticClass:"lyrics-list-stack",attrs:{"column-min-width":320,"gutter-width":12,"gutter-height":12}},[_vm._l((Object.keys(_vm.lyricsList)),function(id){return [_c('stack-item',{key:id},[_c('lyrics-card',{attrs:{"id":id}})],1)]})],2)],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdl-layout-title brand"},[_c('span',{staticClass:"b-lyrics"},[_vm._v("LYRICS")]),_c('span',{staticClass:"b-dot"},[_vm._v(".")]),_c('span',{staticClass:"b-base"},[_vm._v("BASE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7376dc4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(71);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7376dc4b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7376dc4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header"},[_c('header',{staticClass:"mdl-layout__header",class:{'deleting': _vm.deleteConfirmation, 'editing': !_vm.deleteConfirmation}},[_c('div',{staticClass:"mdl-layout__header-row"},[_c('button',{staticClass:"mdl-layout__drawer-button",on:{"click":function($event){_vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._m(0),_c('div',{staticClass:"mdl-layout-spacer"}),_c('nav',{staticClass:"mdl-navigation"},[(!_vm.deleteConfirmation)?[(_vm.$route.params.id !== 'new')?_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteConfirmation = true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e(),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]),(_vm.title !== '')?_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")])]):_vm._e()]:[_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Delete?")]),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteConfirmation = false}}},[_c('i',{staticClass:"material-icons"},[_vm._v("undo")])]),_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteLyrics()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete_forever")])])]],2)])]),_c('main',{staticClass:"mdl-layout__content"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("queue_music")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"title no-border",attrs:{"placeholder":"Song title..."},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_c('input-tag',{attrs:{"tags":_vm.tags,"placeholder":"Tags...","limit":"10"},on:{"update:tags":function($event){_vm.tags=$event}}})],1)]),_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col tools"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("build")]),_c('button',{staticClass:"mdl-button",on:{"click":function($event){_vm.viewingTools = !_vm.viewingTools}}},[(!_vm.viewingTools)?[_vm._v("view tools")]:[_vm._v("hide tools")]],2),(_vm.viewingTools)?[_c('button',{staticClass:"mdl-button mdl-button--raised",attrs:{"disabled":_vm.generating},on:{"click":function($event){_vm.generateFurigana()}}},[(!_vm.generating)?[_vm._v("generate furigana")]:[_vm._v("generating...")]],2)]:_vm._e()],2)]),_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("library_books")]),_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(_vm.editingLyrics),expression:"editingLyrics"},{name:"autosize",rawName:"v-autosize",value:(_vm.lyrics[0].lyrics),expression:"lyrics[0].lyrics"},{name:"model",rawName:"v-model",value:(_vm.lyrics[0].lyrics),expression:"lyrics[0].lyrics"}],staticClass:"lyrics no-border",attrs:{"id":"textarealyrics","placeholder":"Original lyrics..."},domProps:{"value":(_vm.lyrics[0].lyrics)},on:{"blur":function($event){_vm.focusOut()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lyrics[0], "lyrics", $event.target.value)}}}),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editingLyrics),expression:"!editingLyrics"}],staticClass:"lyrics no-border",attrs:{"id":"prelyrics"},domProps:{"innerHTML":_vm._s(_vm.$parseRuby(_vm.lyrics[0].lyrics))},on:{"click":function($event){_vm.focusIn()}}})]),_c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("translate")]),_c('textarea',{directives:[{name:"autosize",rawName:"v-autosize",value:(_vm.lyrics[1].lyrics),expression:"lyrics[1].lyrics"},{name:"model",rawName:"v-model",value:(_vm.lyrics[1].lyrics),expression:"lyrics[1].lyrics"}],staticClass:"lyrics no-border",attrs:{"placeholder":"Translated lyrics..."},domProps:{"value":(_vm.lyrics[1].lyrics)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lyrics[1], "lyrics", $event.target.value)}}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdl-layout-title brand"},[_c('span',{staticClass:"b-lyrics"},[_vm._v("L")]),_c('span',{staticClass:"b-dot"},[_vm._v(".")]),_c('span',{staticClass:"b-base"},[_vm._v("B")]),_c('span',{staticClass:"b-sub"},[_vm._v("/EDITOR")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25401268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__ = __webpack_require__(74);
function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25401268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25401268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header"},[_c('header',{staticClass:"mdl-layout__header"},[_c('div',{staticClass:"mdl-layout__header-row"},[_c('button',{staticClass:"mdl-layout__drawer-button",on:{"click":function($event){_vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._m(0),_c('div',{staticClass:"mdl-layout-spacer"}),_c('nav',{staticClass:"mdl-navigation"},[(!_vm.hiding)?[_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hiding = true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("visibility")])])]:[_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hiding = false}}},[_c('i',{staticClass:"material-icons"},[_vm._v("visibility_off")])])],_c('a',{staticClass:"mdl-navigation__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$router.push('/edit/' + _vm.$route.params.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("mode_edit")])])],2)])]),_c('main',{staticClass:"mdl-layout__content"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("queue_music")]),_c('div',{staticClass:"title no-border"},[_vm._v(_vm._s(_vm.lyricsObj.title))]),_c('input-tag',{attrs:{"tags":_vm.lyricsObj.tags,"read-only":"read-only"},on:{"update:tags":function($event){_vm.$set(_vm.lyricsObj, "tags", $event)}}})],1)]),_c('div',{staticClass:"mdl-grid"},[_vm._m(1),_c('div',{staticClass:"mdl-cell mdl-cell--6-col",class:{'hiding': _vm.hiding}},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("translate")])])]),_vm._l((_vm.splitLines(_vm.$parseRuby(_vm.lyricsObj.lyrics[0].lyrics))),function(text,i){return _c('div',{staticClass:"mdl-grid lyrics-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_c('div',{staticClass:"lyrics no-border"},[(text === '')?_c('p',{staticClass:"blank"}):_c('p',{domProps:{"innerHTML":_vm._s(text)}})])]),_c('div',{staticClass:"mdl-cell mdl-cell--6-col",class:{'hiding': _vm.hiding}},[_c('div',{staticClass:"lyrics no-border"},[(text === '')?_c('p',{staticClass:"blank"}):_c('p',{staticClass:"translated",domProps:{"innerHTML":_vm._s(_vm.splitLines(_vm.$parseRuby(_vm.lyricsObj.lyrics[1].lyrics))[i])}})])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdl-layout-title brand"},[_c('span',{staticClass:"b-lyrics"},[_vm._v("L")]),_c('span',{staticClass:"b-dot"},[_vm._v(".")]),_c('span',{staticClass:"b-base"},[_vm._v("B")]),_c('span',{staticClass:"b-sub"},[_vm._v("/VIEWER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--6-col"},[_c('i',{staticClass:"lyrics-icon material-icons"},[_vm._v("library_books")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[24]);


// WEBPACK FOOTER //
// static/js/app.ebabcb1ef78049acb92b.js